import { Form, InputNumber } from 'antd';
import { HTMLAttributes, useMemo } from 'react';

import styles from './EditableNumber.module.scss';

interface Props extends HTMLAttributes<HTMLElement> {
  name: string;
  value: number;
  editing: boolean;
  required?: boolean;
  disabled?: boolean;
  min?: number;
}

export const EditableNumber = ({ name, value, editing, required, disabled, min }: Props) => {
  const rules = useMemo(
    () => [{ type: 'number' as const, message: '', required, ...(min === undefined ? {} : { min }) }],
    [required, min],
  );

  return editing ? (
    <Form.Item name={name} rules={rules}>
      <InputNumber className={styles.input} size="small" controls={false} disabled={disabled} />
    </Form.Item>
  ) : (
    <Form.Item>
      <InputNumber className={styles.input} size="small" controls={false} value={value} readOnly />
    </Form.Item>
  );
};
